<template>
	<div class="copy-value">
		<!-- <el-tooltip :content="$t('privateNetwork.copy')"
			effect="dark"
			placement="bottom"
			:disabled="copyHover"
			class="tooltip-item">
			<el-tooltip :content="$t('privateNetwork.copySuccess')"
				effect="dark"
				placement="bottom"
				:disabled="!copyHover"
				class="tooltip-item"> -->
				<span @mouseout="copyHoverShow()">
					<el-button type="text"
            :disabled="['undefined', undefined, 'null', null].includes(copyVal)"
						:icon="icon"
						v-clipboard:copy="copyVal"
						v-clipboard:success="onCopy"
						v-clipboard:error="onError">
						<slot name="content">
						</slot>
					</el-button>
				</span>		
			<!-- </el-tooltip>
		</el-tooltip> -->
	</div>
</template>

<script>
export default {
  	name: 'CopyValue',
	props: {
		copyVal: {
			type: [String, Number],
			default: ''
		},
		hasIcon: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		icon(){
			return (this.hasIcon ? 'jc-icon-copy' : '')
		}
	},
  	data() {
		return {
			copyHover: false
		};
  	},
  	methods: {
		// onCopy() {
		// 	this.copyHover = true;
		// },
    onCopy() {
      if (['undefined', undefined, 'null', null].includes(this.copyVal)) return;
      this.copyHover = true;
      this.copyHoverShowTip = this.$t('privateNetwork.copySuccess')
      this.isHasIcon = false;
      this.$message({
          showClose: false,
          message: this.$t('privateNetwork.copySuccess'),
          type: 'success',
          customClass: 'customToastWidth',
      });
      setTimeout(() => {
          this.isHasIcon = true;
      }, 2000);
    },
		onError() {
		  // TODO
		},
		copyHoverShow() {
			setTimeout(() => {
				this.copyHover = false;
			}, 2000)			
		}
  	}
};
</script>

<style scoped lang="scss">
  .copy-value {
		display: inline-block;
    .el-button {
      padding: 0;
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/privateNetwork/CopyValue.vue